import { useTranslation } from 'react-i18next'
import { Badge } from '@/shared/ui/badge'

interface LocationStatusBadgeProps {
  /** Missing value is treated as active (older API payloads). */
  isActive?: boolean | undefined
}

export function LocationStatusBadge({ isActive = true }: LocationStatusBadgeProps) {
  const { t } = useTranslation()
  return (
    <div className="flex justify-center">
      <Badge
        variant="outline"
        className={
          isActive
            ? 'border-blue-200 bg-blue-50 text-blue-700'
            : 'border-zinc-200 bg-zinc-50 text-zinc-500'
        }
      >
        {isActive ? t('common.active') : t('common.inactive')}
      </Badge>
    </div>
  )
}
